// 🔧 volunteer_generator.js
// ✅ Purpose: Generates Volunteer Engine demo data for Core Demo Events
// ✅ Features:
// - Generates volunteer activities
// - Generates time slots for each activity
// - Industry-aware through DemoContext seed profile
// - No Firestore writes
// - No DemoContext mutation
// - Fully block-commented for clarity and future devs

import { buildVolunteerActivities } from "./templates/volunteer_activity_defaults";
import { buildVolunteerTimeSlots } from "./templates/volunteer_time_slot_defaults";

export const generateVolunteers = ({
  demoContext,
} = {}) => {
  console.log("🙋 Volunteer Generator started.");

  const industryTemplate =
    demoContext?.industryTemplate?.key ||
    demoContext?.demoConfig?.industry ||
    "car_show";

  const demoSize =
    demoContext?.demoConfig?.size ||
    demoContext?.seedProfile?.demoSize ||
    "medium";

  const activities = buildVolunteerActivities({
    industryTemplate,
  });

  const timeSlots = buildVolunteerTimeSlots({
    industryTemplate,
    demoSize,
    activities,
    demoContext,
  });

  console.log("✅ Volunteer Generator completed.", {
    activities: activities.length,
    timeSlots: timeSlots.length,
  });

  return {
    activities,
    timeSlots,
  };
};
